<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 16 21">
    <g clip-path="url(#clip0_6892_9183)">
      <path
        d="M16 16.9965L1.48148 2.36719L0.924444 2.90426L2.65481 4.64389C2.48889 5.14594 2.37037 5.65966 2.37037 6.22008V9.7227C2.37037 12.6182 4.76444 14.9766 7.7037 14.9766C9.14963 14.9766 10.4415 14.3929 11.4015 13.4705L13.0489 15.1284C12.2904 15.7472 11.2593 16.1442 10.0741 16.1442H5.33333C3.04593 16.1442 1.18519 14.7081 1.18519 12.9334V9.13893H0V12.9334C0 15.3503 2.39407 17.3117 5.33333 17.3117H7.11111V20.8144H8.2963V17.3117H10.0741C11.5793 17.3117 12.8948 16.7747 13.8667 15.9457L15.443 17.5336L16 16.9965ZM4.78815 6.79217H3.55556V6.2084C3.55556 5.99824 3.57926 5.79976 3.61481 5.60128L4.8 6.79217H4.78815ZM7.7037 13.7974C5.4163 13.7974 3.55556 11.9644 3.55556 9.71103V7.95972H5.94963L10.56 12.6065C9.81333 13.3304 8.81778 13.7974 7.69185 13.7974H7.7037Z"
        :class="colorClass"
      />
      <path
        d="M8.60453 0.861111V0.802734H7.41935V0.861111C5.73638 1.04792 4.29046 2.0053 3.44897 3.37133L4.32601 4.25866C4.51564 3.87337 4.74083 3.51143 5.03712 3.20787V4.98254L5.52305 5.4729H6.22231V2.37892C6.58972 2.20379 6.99268 2.08703 7.40749 2.02865V5.4729H8.59268V2.02865C9.00749 2.08703 9.41046 2.20379 9.77786 2.37892V5.4729H10.963V3.20787C11.6979 3.94342 12.1482 4.94751 12.1482 6.05667V6.64045H6.68453L7.84601 7.80799H12.1482V9.5593C12.1482 10.2949 11.9349 10.9837 11.5912 11.5791L12.4327 12.4198C12.9897 11.5908 13.3453 10.6218 13.3453 9.54763V6.045C13.3453 3.35965 11.2593 1.153 8.60453 0.861111Z"
        :class="colorClass"
      />
      <path
        d="M14.5304 8.97559V12.7701C14.5304 13.2605 14.3763 13.7158 14.1274 14.1244L14.9689 14.9651C15.443 14.3229 15.7274 13.5757 15.7274 12.7701V8.97559H14.5423H14.5304Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9183">
        <rect width="16" height="20" fill="white" transform="translate(0 0.802734)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
